<template>
  <div class="video-play">
    <video v-if="m3u8" class="full-height full-width" ref="video" controls id="video"></video>
    <video v-else :src="url" autoplay controls></video>
  </div>
</template>
<script>
let Hls = require("hls.js");
export default {
  data() {
    return {
      url: "",
      m3u8:true
    };
  },
  methods: {
    getMsg() {
      
      if (Hls.isSupported()) {
        var video = document.getElementById("video");
        var hls = new Hls();
        hls.loadSource(this.url);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function() {
          video.play();
        });
      }
    }
  },
  mounted() {
    this.url = this.$route.query.newpath;    
    if(this.url.indexOf('m3u8')>-1){
      this.getMsg()
    }else{
      this.m3u8 = false
    }
    
  }
};
</script>
<style lang='scss' scoped>
.video-play {
  video {
    margin-top: 0.2rem;
    width: 94%;
  }
  text-align: center;
  padding-top: 0.9rem;
  font-size: 0.3rem;
}
</style>